import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-semibold text-black mb-6 select-none" }
const _hoisted_2 = { class: "flex max-md:flex-col flex-wrap gap-4 mb-6 md:mb-10" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "size-9 md:size-12 bg-white rounded-full flex items-center justify-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-brown text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "w-[65px] h-6 bg-active rounded-lg px-2 py-1 text-white text-xs sf-pro absolute top-[14px] right-2 md:top-1 md:right-1"
}
const _hoisted_8 = { class: "flex justify-between items-center px-4 text-base text-brown" }
const _hoisted_9 = { class: "flex gap-4" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "flex-1 flex justify-end" }
const _hoisted_13 = {
  key: 1,
  class: "text-center text-brown text-sm mb-6"
}
const _hoisted_14 = {
  key: 1,
  class: "font-semibold text-white text-xl leading-[24px] select-none"
}

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import BaseModal from "@/views/Auth/components/BaseModal.vue";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import { fetchStripeUrl } from "@/api/subscription";
import AppDropdown from "@/components/inputs/AppDropdown.vue";
import ChevronIcon from "@/components/icons/ChevronIcon.vue";
import { SubscriptionPrice, Subscription } from "@/types/subscription";
import { useSubscriptionPricesStore } from "@/stores/subscriptionPricesStore";
import { PREMIUM_CALCULATORS, PremiumCalculator } from "@/types/premiumTypes";
import activationCalendarIcon from "@/assets/icons/menu/activationCalendar.svg";
import layoutRoomsIcon from "@/assets/icons/menu/layoutRooms.svg";
import destinyMatrixIcon from "@/assets/icons/menu/destinyMatrix.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionModal',
  props: {
    show: { type: Boolean },
    defaultSelected: {},
    currentSubscriptions: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const { t } = useI18n();
const { getSubscriptionPrices } = useSubscriptionPricesStore();
const waitApiCall = ref(false);
const isDropdownOpen = ref(false);
const subscriptionPrices = ref<SubscriptionPrice[]>([]);
const selectedPrice = ref<SubscriptionPrice>();
const selectedCalculator = ref<PremiumCalculator>();

const currencies = {
  uah: "₴",
  usd: "$",
};
const ALL_PREMIUM_CALCULATORS = Object.values(PREMIUM_CALCULATORS);

const calculatorsWithTips: PremiumCalculator[] = [
  PREMIUM_CALCULATORS.activations,
];

onMounted(async () => {
  await handleChangeCalculator(props.defaultSelected);
});

async function handleSubscribe() {
  if (!selectedPrice.value) {
    return;
  }
  try {
    waitApiCall.value = true;
    const stripeUrl = await fetchStripeUrl(selectedPrice.value);
    if (stripeUrl) {
      window.location.href = stripeUrl;
    }
  } catch (e) {
    console.error(e);
  } finally {
    waitApiCall.value = false;
  }
}

function selectItem(item: SubscriptionPrice) {
  selectedPrice.value = item;
  isDropdownOpen.value = false;
}

function getCalculatorIcon(premiumCalculator: PremiumCalculator) {
  switch (premiumCalculator) {
    case PREMIUM_CALCULATORS.activations:
      return activationCalendarIcon;
    case PREMIUM_CALCULATORS.apartmentPlan:
      return layoutRoomsIcon;
    case PREMIUM_CALCULATORS.destinyMatrix:
      return destinyMatrixIcon;
    default:
      return null;
  }
}

function isActiveSubscription(premiumCalculator: PremiumCalculator) {
  if (props.currentSubscriptions === undefined) {
    return false;
  }
  const subscription = props.currentSubscriptions.find(
    (sub) => sub.is_active && sub.calculator === premiumCalculator
  );

  return subscription?.is_active ?? false;
}

async function handleChangeCalculator(premiumCalculator: PremiumCalculator) {
  try {
    waitApiCall.value = true;
    subscriptionPrices.value = await getSubscriptionPrices(premiumCalculator);
    selectedCalculator.value = premiumCalculator;
    selectedPrice.value = subscriptionPrices.value[0];
  } catch (e) {
    console.error(e);
  } finally {
    waitApiCall.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close'))),
    "max-height": "472px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("subscription.premium-title")), 1),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ALL_PREMIUM_CALCULATORS), (premiumCalculator) => {
          return (_openBlock(), _createElementBlock("div", {
            key: premiumCalculator,
            class: _normalizeClass(["w-full h-[52px] md:w-[170px] md:h-[136px] border p-2 md:p-4 rounded-lg flex gap-2 md:flex-col md:gap-4 max-md:items-center relative select-none", {
          'border-active bg-hover': selectedCalculator.value === premiumCalculator,
          'border-muted': selectedCalculator.value !== premiumCalculator,
          'cursor-pointer':
            !isActiveSubscription(premiumCalculator) &&
            selectedCalculator.value !== premiumCalculator,
        }]),
            onClick: ($event: any) => (
          !isActiveSubscription(premiumCalculator)
            ? handleChangeCalculator(premiumCalculator)
            : null
        )
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: getCalculatorIcon(premiumCalculator),
                alt: "",
                class: "size-6 md:size-8"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)(`subscription.${premiumCalculator}.name`)), 1),
            (isActiveSubscription(premiumCalculator))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Активна "))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      (subscriptionPrices.value.length > 0)
        ? (_openBlock(), _createBlock(AppDropdown, {
            key: 0,
            label: _unref(t)('subscription.premium-type'),
            items: subscriptionPrices.value,
            selectedItem: selectedPrice.value,
            isDropdownOpen: isDropdownOpen.value,
            class: _normalizeClass(
        calculatorsWithTips.includes(selectedCalculator.value) ? 'mb-2' : 'mb-6'
      ),
            onToggle: _cache[0] || (_cache[0] = ($event: any) => (isDropdownOpen.value = !isDropdownOpen.value))
          }, {
            selectedItem: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)(`subscription.${selectedCalculator.value}.tiers.${item.tier}`)), 1),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(currencies[item.currency]) + _toDisplayString(item.amount) + "/" + _toDisplayString(_unref(t)(`subscription.interval.${item.interval}`)), 1),
                  _createVNode(ChevronIcon, {
                    class: _normalizeClass(["transition-transform", isDropdownOpen.value ? 'rotate-180' : 'rotate-0'])
                  }, null, 8, ["class"])
                ])
              ])
            ]),
            dropdownItem: _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "flex items-center px-4 text-base text-brown h-10 hover:bg-divider cursor-pointer select-none",
                onClick: () => selectItem(item)
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)(`subscription.${selectedCalculator.value}.tiers.${item.tier}`)), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(currencies[item.currency]) + _toDisplayString(item.amount) + "/" + _toDisplayString(_unref(t)(`subscription.interval.${item.interval}`)), 1)
              ], 8, _hoisted_10)
            ]),
            _: 1
          }, 8, ["label", "items", "selectedItem", "isDropdownOpen", "class"]))
        : _createCommentVNode("", true),
      (
        selectedPrice.value && calculatorsWithTips.includes(selectedPrice.value.calculator)
      )
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)(`subscription.${selectedPrice.value.calculator}.tips.${selectedPrice.value.tier}`)), 1))
        : _createCommentVNode("", true),
      (selectedPrice.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["w-full h-14 rounded-full bg-orange-gradient", {
        'opacity-40 pointer-events-none': waitApiCall.value,
      }]),
            onClick: handleSubscribe
          }, [
            (waitApiCall.value)
              ? (_openBlock(), _createBlock(LoaderIcon, { key: 0 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)("buttons.subscription.confirm-subscription", {
            currency: currencies[selectedPrice.value.currency],
            price: selectedPrice.value.amount,
          })), 1))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})